import { isExternalUrl } from "./utils";
import { getCookiesWithRetry } from "./nats-client";
import { log } from "./logger";

const tag = "cookieValidation";

export async function validateCookiesForUrl(url: string): Promise<void> {
  // Don't validate cookies for external URLs
  if (isExternalUrl(url)) {
    log.debug(tag, "Skipping cookie validation for external URL:", url);
    return;
  }

  // For internal URLs, ensure Api.Token cookie is available
  try {
    log.debug(tag, "Validating cookies for internal URL:", url);
    await getCookiesWithRetry();
    log.debug(tag, "Cookie validation successful for URL:", url);
  } catch (error) {
    log.error(tag, "Cookie validation failed for URL:", url, error);
    throw new Error(`Failed to validate authentication cookies for ${url}`);
  }
}